'use strict';

function FareAdjustmentsPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fare-adjustments-panel.html'),
    controller: 'FaresAdjustmentsPanelController'
  };
}
FareAdjustmentsPanelDirective.$inject = [];
module.exports = FareAdjustmentsPanelDirective;